// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"31d6cfe0","579":"5e07eada"}[chunkId] + ".chunk.css";
};